var _span, _CrehanaLogoIso;
import { memo } from "react";
import CrehanaLogoIso from "@crehana/icons/CrehanaLogoIso";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var PoweredBy = function PoweredBy() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [_span || (_span = /*#__PURE__*/_jsx("span", {
      className: "tw-font-body5 tw-mr-0.8 tw-text-neutral-light-500",
      children: "Powered by"
    })), _CrehanaLogoIso || (_CrehanaLogoIso = /*#__PURE__*/_jsx(CrehanaLogoIso, {
      size: 12,
      ignoreColor: true,
      className: "tw-fill-current tw-text-neutral-light-500"
    }))]
  });
};
export default /*#__PURE__*/memo(PoweredBy);